import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/home/header.png'
import _imports_1 from '@/assets/home/tt.png'
import _imports_2 from '@/assets/home/d.png'
import _imports_3 from '@/assets/home/ins.png'
import _imports_4 from '@/assets/home/tg.png'
import _imports_5 from '@/assets/home/bb.png'
import _imports_6 from '@/assets/home/fishbone.png'
import _imports_7 from '@/assets/mobile/fishbone.png'
import _imports_8 from '@/assets/home/hua.png'


const _hoisted_1 = { class: "home-page" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "link-main scroll-fade" }
const _hoisted_4 = { class: "title scroll-fade" }
const _hoisted_5 = { class: "sub-title scroll-fade" }
const _hoisted_6 = { class: "info scroll-fade" }
const _hoisted_7 = { class: "our-series scroll-fade" }
const _hoisted_8 = { class: "list-item scroll-fade" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "block" }
const _hoisted_11 = { class: "time" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "nft" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "block" }
const _hoisted_16 = { class: "time" }
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { class: "nft" }
const _hoisted_19 = { class: "fishbone scroll-fade" }
const _hoisted_20 = { class: "fishbone-item first" }
const _hoisted_21 = { class: "fishbone-item two" }
const _hoisted_22 = { class: "fishbone-item three" }
const _hoisted_23 = { class: "fishbone-item five" }

import { ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import Flow from "@/components/flow.vue";
import Footer from "@/components/footer.vue";
import Xk from "@/components/xk.vue";
import {
  visitorPvApi,
  xUrlApi,
  tgUrlApi,
  insUrlApi,
  disUrlApi,
} from "@/api/other";
import { nftApi } from "@/api/nft";

// 接口定义
interface ApiResponse<T = any> {
  code: number;
  data: T;
  message?: string;
}

interface ProjectItem {
  id: string;
  name: string;
  imageResource?: {
    url: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const router = useRouter();
const { t } = useI18n();

const formatDate = (dateString: string) => {
  if (!dateString) return "";
  return dateString.split("-").slice(0, 2).join("-");
};
// 响应式状态
const isVisible = ref(false);
const isAn = ref(true);
const projectList = ref<ProjectItem[]>([]);
let observer: IntersectionObserver | null = null;

// 获取项目列表
const getProject = async () => {
  try {
    const res = await nftApi.getProjects();
    if (res.code === 200) {
      projectList.value = res.data;
    }
  } catch (error) {
    console.error("Failed to fetch projects:", error);
  }
};
// 跳转购买
const goMarket = () => {
  router.push({ path: "/market", query: {} });
};
// 社交媒体跳转
const goPathUrl = async (type: string) => {
  let api;
  switch (type) {
    case "tg":
      api = tgUrlApi;
      break;
    case "dis":
      api = disUrlApi;
      break;
    case "ins":
      api = insUrlApi;
      break;
    case "x":
      api = xUrlApi;
      break;
  }

  if (api) {
    try {
      const res = await api();
      if (res.code === 200 && res.data) {
        window.location.href = res.data as string;
      }
    } catch (error) {
      console.error(`Failed to fetch ${type} URL:`, error);
    }
  }
};
const goChild = () => {
  router.push({ path: "/child", query: {} });
};
// 初始化滚动动画
const initScrollAnimation = () => {
  const scrollElements = document.querySelectorAll(".scroll-fade");

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in");
        } else {
          entry.target.classList.remove("fade-in");
        }
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    }
  );

  scrollElements.forEach((el) => {
    observer?.observe(el);
  });
};

// 访客统计
const recordVisit = async (sessionId: string) => {
  try {
    await visitorPvApi(sessionId);
  } catch (error) {
    console.error("Failed to record visit:", error);
  }
};

// 生命周期钩子
onMounted(() => {
  window.scrollTo(0, 0);

  setTimeout(() => {
    isVisible.value = !isVisible.value;
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      recordVisit(sessionId);
    }
  }, 3000);

  initScrollAnimation();
  getProject(); // 获取项目列表
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!isVisible.value)
          ? (_openBlock(), _createBlock(Xk, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (isVisible.value)
      ? (_openBlock(), _createBlock(Flow, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "header-icon scroll-fade"
      }, null, -1)),
      _createElementVNode("div", {
        class: "go-buy",
        onClick: goMarket
      }, _toDisplayString(_unref(t)("home.goBuy")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: "",
          class: "tt-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goPathUrl('x')))
        }),
        _createElementVNode("img", {
          src: _imports_2,
          alt: "",
          class: "d-icon",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (goPathUrl('dis')))
        }),
        _createElementVNode("img", {
          src: _imports_3,
          alt: "",
          class: "ins-icon",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (goPathUrl('ins')))
        }),
        _createElementVNode("img", {
          src: _imports_4,
          alt: "",
          class: "ins-icon margin-left-two",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (goPathUrl('tg')))
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("home.title")), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)("home.subTitle")), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)("home.info")), 1),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)("home.ourSeries")), 1),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectList.value, (item) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.id === '1876926030669729794')
              ? (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  key: item.id,
                  onClick: goChild
                }, [
                  _createElementVNode("img", {
                    class: "item-img",
                    src: item.imageResource.url,
                    alt: ""
                  }, null, 8, _hoisted_9),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "item-bg" }, null, -1)),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(formatDate(item.publishTime)), 1),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("home.iceAge")), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("home.similarFate")), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  class: "item",
                  style: _normalizeStyle({ 'background-image': `url(${item.imageResource.url})` }),
                  key: item.id
                }, [
                  _createElementVNode("img", {
                    class: "item-img",
                    src: item.imageResource.url,
                    alt: ""
                  }, null, 8, _hoisted_14),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "item-bg" }, null, -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("home.comingSoon")), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("home.cretaceous")), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("home.toBeSoon")), 1)
                  ])
                ], 4))
          ], 64))
        }), 256))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("div", { class: "more scroll-fade" }, [
        _createElementVNode("img", {
          src: _imports_5,
          alt: "",
          class: "more-bg"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_19, [
        _cache[6] || (_cache[6] = _createElementVNode("img", {
          src: _imports_6,
          alt: "",
          class: "fishbone-img"
        }, null, -1)),
        _cache[7] || (_cache[7] = _createElementVNode("img", {
          src: _imports_7,
          alt: "",
          class: "fishbone-mobile-img"
        }, null, -1)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.OfficialWebsiteRelease")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.OfficialWebsiteReleaseTime")), 1)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.firstBatch")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.toBeSoon")), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.FreeMarketRelease")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.toBeSoon")), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.ChainTravel")), 1),
          _createElementVNode("div", null, _toDisplayString(_unref(t)("home.toBeSoon")), 1)
        ])
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "up scroll-fade" }, [
        _createTextVNode(" \"NEVER GONNA GIVE YOU UP.\" "),
        _createElementVNode("img", {
          src: _imports_8,
          alt: "",
          class: "hua-icon"
        })
      ], -1)),
      _createVNode(Footer)
    ])
  ]))
}
}

})